import * as React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'

const MdHeader = ({ children, style, className }) => {
  return (
    <div style={style} className={className}>
      {children}
    </div>
  )
}

const MdBold = ({ children, style, className, onClick, onKeyDown }) => {
  return (
    <div
      onClick={onClick}
      onKeyDown={onKeyDown}
      style={style}
      className={className}>
      {children}
    </div>
  )
}

const MdItalic = ({ children, style, className, onClick, onKeyDown }) => {
  return (
    <div
      onClick={onClick}
      onKeyDown={onKeyDown}
      style={style}
      className={className}>
      {children}
    </div>
  )
}

const useStyles = createUseStyles(
  {
    'input-xyz': {
      display: 'inline-block'
    },
    container: {
      position: 'relative',
      color: '#c9d1d9',
      backgroundColor: '#0d1117',
      border: '1px solid #30363d',
      borderRadius: '6px',
      margin: '16px',
      '& *': {
        boxSizing: 'border-box'
      }
    },
    caret: {
      '&:after': {
        position: 'absolute',
        top: '11px',
        right: '100%',
        left: '-8px',
        display: 'block',
        width: '8px',
        height: '16px',
        pointerEvents: 'none',
        clipPath: 'polygon(0 50%,100% 0,100% 100%)'
      },
      '&:before': {
        position: 'absolute',
        top: '11px',
        right: '100%',
        left: '-8px',
        display: 'block',
        width: '8px',
        height: '16px',
        pointerEvents: 'none',
        clipPath: 'polygon(0 50%,100% 0,100% 100%)'
      }
    },

    'fieldset-xyz': {
      display: 'grid',
      borderRadius: '8px',
      padding: 0,
      margin: 0,
      border: 0
    },
    tabnav: {
      marginTop: 0,
      // marginBottom: '8px',
      borderBottom: '1px solid #30363d'
    },
    'tabnav-head': {
      // padding: '8px 8px 0',
      marginBottom: '8px',
      background: '#161b22',
      borderRadius: '6px 6px 0 0'
    },

    'tabnavs-header': {
      background: '#161b22'
    },

    'tabnav-tabs': {
      display: 'block !important',
      marginBottom: '-1px',
      overflow: 'auto'
    },
    'tabnav-tab': {
      display: 'inline-block',
      flexShrink: 0,
      padding: '8px 16px',
      fontSize: '14px',
      lineHeight: '23px',
      color: '#8b949e',
      textDecoration: 'none',
      backgroundColor: 'initial',
      border: '1px solid transparent',
      borderBottom: 0,
      transition: 'color .2s cubic-bezier(.3,0,.5,1)',
      '&[aria-selected=true]': {
        color: '#c9d1d9',
        backgroundColor: '#0d1117',
        borderColor: '#30363d',
        borderRadius: '6px 6px 0 0'
      },
      '&:focus': {
        outline: 'none'
      }
    },
    'btn-link': {
      display: 'inline-block',
      // padding: 0,
      fontSize: 'inherit',
      color: '#58a6ff',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      userSelect: 'none',
      backgroundColor: 'initial',
      // border: 0,
      appearance: 'none'
    },
    toolbar: {
      background: '#0d1117'
    },
    flex: {
      display: 'flex!important'
    },
    border: {
      border: '1px solid #30363d !important'
    },
    'border-color': {
      borderColor: '#30363d !important'
    },
    'border-bottom': {
      borderBottom: '0 !important'
    },
    'border-top': {
      borderTop: '1px solid #30363d !important'
    },
    'my-4': {
      marginRight: '4px !important',
      marginLeft: '4px !important'
    },
    'mx-8': {
      marginTop: '8px !important',
      marginBottom: '8px !important'
    },
    'my-8': {
      marginRight: '8px !important',
      marginLeft: '8px !important'
    },
    'my-16': {
      marginRight: '16px !important',
      marginLeft: '16px !important'
    },
    'mr-16': {
      marginRight: '16px !important'
    },
    'py-16': {
      paddingRight: '16px !important',
      paddingLeft: '16px !important'
    },
    'pt-8': {
      paddingTop: '8px !important'
    },
    'pyt-8': {
      paddingRight: '8px !important',
      paddingLeft: '8px !important',
      paddingTop: '8px !important'
    },
    'mt-8': {
      marginTop: '8px !important'
    },
    'md-block': {
      display: 'block !important'
    },
    textarea: {
      width: '100%',
      height: '150px',
      borderRadius: '6px',
      outline: 'none',
      background: 'transparent',
      padding: '14px',
      color: 'white',
      overflowX: 'hidden',
      resize: 'vertical',
      cursor: 'text',
      whiteSpace: 'pre-wrap',
      overflowWrap: 'break-word'
    },
    'toolbar-item': {
      display: 'block',
      float: 'left',
      padding: '4px',
      fontSize: '14px',
      fill: '#8b949e',
      cursor: 'pointer',
      background: 'none',
      border: 0,
      '&:hover': {
        fill: '#58a6ff'
      }
    }
  },
  { name: 'bund-' }
)

export const CommentBoxBase = (props) => {
  const { children, title, className, style, handleSubmit, ...rest } = props
  const classes = useStyles()
  return (
    <div
      className={clsx(
        classes.container,
        classes.border,
        classes.caret,
        className
      )}>
      <form onSubmit={handleSubmit} noValidate>
        <fieldset
          className={clsx(classes['fieldset-xyz'], className)}
          {...rest}
          style={{
            borderRadius: '8px',
            padding: 0,
            margin: 0
          }}>
          <div
            className={clsx(
              classes['tabnav'],
              classes['border-color'],
              classes['border-bottom']
            )}>
            <div
              className={clsx(
                classes['tabnav-head'],
                classes['tabnavs-header']
              )}>
              <div
                className={clsx(
                  classes['tabnav-tabs'],
                  classes['my-8'],
                  classes['pt-8'],
                  classes['md-block'],
                  className
                )}
                role="tablist">
                <button
                  type="button"
                  className={clsx(
                    classes['tabnav-tab'],
                    classes['py-16'],
                    classes['btn-link'],
                    className
                  )}
                  role="tab"
                  aria-selected="true"
                  tabIndex="0">
                  Write
                </button>
                <button
                  type="button"
                  className={clsx(
                    classes['tabnav-tab'],
                    classes['py-16'],
                    classes['btn-link'],
                    className
                  )}
                  role="tab"
                  aria-selected="false"
                  tabIndex="-1">
                  Preview
                </button>

                <div
                  className="bitmoji-floater"
                  style={{
                    backgroundPosition: '0px center',
                    backgroundImage:
                      'url(chrome-extension://bfgdeiadkckfbkeigkoncpdieiiefpig/static/media/bitmoji-icon-48.png)',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    width: '28px',
                    height: '28px',
                    marginBottom: '-8px',
                    display: 'inline-block'
                  }}
                />
              </div>
              <div
                className={clsx(
                  classes.toolbar,
                  classes.flex,
                  classes['pyt-8'],
                  classes['border-top']
                )}>
                <div
                  className={clsx(
                    classes['mr-16'],
                    'flex-nowrap d-none d-md-inline-block mr-3'
                  )}
                  style={{
                    display: 'inline-block !important',
                    marginRight: '16px !important',
                    flexWrap: 'nowrap !important'
                  }}>
                  <MdHeader
                    tabindex="-1"
                    className={clsx(
                      classes['toolbar-item'],
                      classes['my-4'],
                      'toolbar-item tooltipped tooltipped-sw mx-1'
                    )}
                    aria-label="Add header text"
                    data-ga-click="Markdown Toolbar, click, header"
                    role="button">
                    <svg
                      className="octicon octicon-heading"
                      height="16"
                      viewBox="0 0 16 16"
                      version="1.1"
                      width="16"
                      aria-hidden="true">
                      <path
                        fillRule="evenodd"
                        d="M3.75 2a.75.75 0 01.75.75V7h7V2.75a.75.75 0 011.5 0v10.5a.75.75 0 01-1.5 0V8.5h-7v4.75a.75.75 0 01-1.5 0V2.75A.75.75 0 013.75 2z"></path>
                    </svg>
                  </MdHeader>

                  <MdBold
                    tabindex="-1"
                    className={clsx(classes['toolbar-item'], classes['my-4'])}
                    aria-label="Add bold text <ctrl+b>"
                    data-ga-click="Markdown Toolbar, click, bold"
                    role="button"
                    onClick={() => console.log('clicked')}
                    hotkey="b">
                    <svg
                      className="octicon octicon-bold"
                      height="16"
                      viewBox="0 0 16 16"
                      version="1.1"
                      width="16"
                      aria-hidden="true">
                      <path
                        fillRule="evenodd"
                        d="M4 2a1 1 0 00-1 1v10a1 1 0 001 1h5.5a3.5 3.5 0 001.852-6.47A3.5 3.5 0 008.5 2H4zm4.5 5a1.5 1.5 0 100-3H5v3h3.5zM5 9v3h4.5a1.5 1.5 0 000-3H5z"></path>
                    </svg>
                  </MdBold>

                  <MdItalic
                    tabindex="-1"
                    className={clsx(
                      classes['toolbar-item'],
                      classes['my-4'],
                      'toolbar-item tooltipped tooltipped-sw mx-1'
                    )}
                    aria-label="Add italic text <ctrl+i>"
                    data-ga-click="Markdown Toolbar, click, italic"
                    role="button"
                    hotkey="i">
                    <svg
                      className="octicon octicon-italic"
                      height="16"
                      viewBox="0 0 16 16"
                      version="1.1"
                      width="16"
                      aria-hidden="true">
                      <path
                        fillRule="evenodd"
                        d="M6 2.75A.75.75 0 016.75 2h6.5a.75.75 0 010 1.5h-2.505l-3.858 9H9.25a.75.75 0 010 1.5h-6.5a.75.75 0 010-1.5h2.505l3.858-9H6.75A.75.75 0 016 2.75z"></path>
                    </svg>
                  </MdItalic>
                </div>
              </div>
            </div>
            <div>
              <div className={clsx(classes['mx-8'], classes['my-8'])}>
                <textarea
                  name="Text1"
                  cols="40"
                  rows="5"
                  className={classes.textarea}
                />
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  )
}

CommentBoxBase.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  title: PropTypes.string
}

CommentBoxBase.displayName = 'cbb'

export default CommentBoxBase
